/**
 * Eén regel onder de datasettabel: hoe het met de foto's staat. Op schijf, nog
 * te halen, opgegeven, en hoeveel van het budget er is gebruikt. Staat de haler
 * stil omdat het budget vol is, dan zegt de regel dat - in tekst, niet in rood.
 */
import { formatAantal } from '@mamimap/shared';
import { useFotoStand } from '@/lib/api/queries';
import { formatBytes } from './DatasetTabel';

export function FotoStandRegel() {
  const stand = useFotoStand();
  if (!stand.data) return null;
  const { bewaard, teHalen, mislukt, bytes, budgetBytes, actief, gestopt } = stand.data;
  if (bewaard === 0 && teHalen === 0 && mislukt === 0) return null;

  const delen = [
    `${formatAantal(bewaard)} foto’s op schijf (${formatBytes(bytes)} van ${formatBytes(budgetBytes)})`,
  ];
  if (teHalen > 0) delen.push(`${formatAantal(teHalen)} nog te halen`);
  if (mislukt > 0) delen.push(`${formatAantal(mislukt)} opgegeven`);
  if (gestopt) delen.push('het budget is vol, de fotohaler staat stil');
  else if (!actief) delen.push('de fotohaler staat uit');

  return <p className="text-[11.5px] text-muted">{delen.join(' · ')}</p>;
}
